module.exports = __webpack_public_path__ + "static/media/time-arrow.007b6e5e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bus-eireann/time-arrow.svg
// module id = 654
// module chunks = 0